import RadioGroup from 'Components/input/RadioGroup/RadioGroup'
import { FormikProps } from 'formik'
import { UserFormValues } from 'pages/User/Create'
import React from 'react'
import { useSelector } from 'react-redux'
import { Col, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap'
import { RootState } from 'store'

const UserFormFields:React.FC<{formFields: FormikProps<UserFormValues>, editMode?: boolean}> = ({formFields, editMode=false}) => {

    const roles = useSelector((state: RootState) => state.roles.items);
  return (
    <Row>
        <Col xl={12}>
            <FormGroup>
                <Label>Name</Label>
                <Input 
                    value={formFields.values.name} 
                    onChange={(e) => formFields.setFieldValue('name', e.target.value)} 
                    invalid={!!formFields.errors.name} 
                    placeholder='Enter Full Name'
                    disabled={editMode} // Disable input if in edit mode
                />
                {
                    formFields.touched.name && formFields.errors.name &&
                    <FormFeedback>
                        {formFields.values.name}
                    </FormFeedback>
                }
            </FormGroup>
            <FormGroup>
                <Label>Email</Label>
                <Input 
                    value={formFields.values.email} 
                    onChange={(e) => formFields.setFieldValue('email', e.target.value)} 
                    invalid={!!formFields.errors.email} 
                    placeholder='Enter Email'
                    disabled={editMode} // Disable input if in edit mode
                />
                {
                    formFields.touched.email && formFields.errors.email &&
                    <FormFeedback>
                        {formFields.values.email}
                    </FormFeedback>
                }
            </FormGroup>
            <FormGroup>
                <Label>Role</Label>
                <RadioGroup
                        name="role"
                        options={roles.map((role) => ({ id: role.slug, label: role.name }))}
                        defaultValue={formFields.values.role?.slug}
                        onChange={(selectedRoleSlug) => {
                            formFields.setFieldValue('role', roles.find((role) => role.slug === selectedRoleSlug))
                        }}
                    />

            </FormGroup>
        </Col>
    </Row>
  )
}

export default UserFormFields